module.exports = __webpack_public_path__ + "assets/a-shu2.5f8971ba.svg";